// extracted by mini-css-extract-plugin
export default {"close":"BoardTask_close__pqHII","icon":"BoardTask_icon__Hru54","users":"BoardTask_users__CgssX","user":"BoardTask_user__z-VAl"};